import * as z from 'zod'

export const stageInputStands = ['short-boom', 'tall-boom', 'straight', 'clip', 'none'] as const
export type StageInputStand = (typeof stageInputStands)[number]

export const stageInputStandLabels: Record<StageInputStand, string> = {
  'short-boom': 'Short boom',
  'tall-boom': 'Tall boom',
  straight: 'Straight',
  clip: 'Clip',
  none: 'None',
}

/**
 * One channel on the desk, as the member describes it (docs/ux/2026-10-16-rider-collaboration-ux.md, "Inputs and
 * gear"). Lives in user config, which is dropped WHOLE on a failed parse, so enums degrade instead of failing.
 */
export const stageInputSchema = z.object({
  /** Stable across sync, so a later rider-level order can key on it */
  id: z.string(),
  source: z.string(),
  micDi: z.string().optional(),
  stand: z.enum(stageInputStands).optional().catch(undefined),
  /** Needs phantom power (48V) */
  phantomPower: z.boolean().optional(),
  /** The performance part a preset row came from. Plain string: read it through isPerformancePart. */
  part: z.string().optional(),
  /** Whether the artist brings it (vs venue/production) */
  providedByArtist: z.boolean().default(false),
  notes: z.string().optional(),
})

export type StageInput = z.infer<typeof stageInputSchema>

/** A list that keeps its valid items: one bad row must not cost the member every input, or their config. */
export const stageInputListSchema = z.preprocess(
  value => (Array.isArray(value) ? value.filter(item => stageInputSchema.safeParse(item).success) : value),
  z.array(stageInputSchema)
)
